export const HOME_ROUTE = "/";
export const EVENT_ROUTE = "/events/alphabet_of_scars";
export const EVENT_PROGRAM_ROUTE = `${EVENT_ROUTE}/schedule`;
export const LK_ROUTE = "/lk";
export const LK_PROFILE_ROUTE = `${LK_ROUTE}/profile`;
export const LK_EVENTS_ROUTE = `${LK_ROUTE}/events`;
export const LK_EVENT_RECORDS_ROUTE = `${LK_EVENTS_ROUTE}/:eventId`;
export const RECORDS_ROUTE = `/records`;

export const RECORD_ROUTE = `${RECORDS_ROUTE}/:recordId`;
export const RECORD_CHECK_ROUTE = `${RECORD_ROUTE}/check`;

export const USER_ROLES = {
  GUEST: "Guest",
  MANAGER: "Manager",
  CLIENT: "Client",
};

export const ROLE_LABELS = {
  [USER_ROLES.CLIENT]: "Клиент",
  [USER_ROLES.MANAGER]: "Менеджер",
};

export const getRoleLabel = (role) => ROLE_LABELS[role] || "Неизвестная роль";
